import React from 'react';
import { InputAdornment, TextField, type SxProps, type Theme } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

export type MinimumLengthSearchFieldProps = {
  value: string;
  onChange: (value: string) => void;
  minimumLength?: number;
  placeholder?: string;
  sx?: SxProps<Theme>;
};

const MinimumLengthSearchField: React.FC<MinimumLengthSearchFieldProps> = ({
  value,
  onChange,
  minimumLength = 3,
  placeholder = 'Search...',
  sx,
}) => {
  const hasIncompleteSearch = value.trim().length > 0 && value.trim().length < minimumLength;

  return (
    <TextField
      size="small"
      placeholder={placeholder}
      value={value}
      onChange={(event) => onChange(event.target.value)}
      error={hasIncompleteSearch}
      helperText={hasIncompleteSearch ? `Enter at least ${minimumLength} characters to search.` : undefined}
      inputProps={{ 'aria-invalid': hasIncompleteSearch }}
      sx={{
        ...sx,
        '& .MuiOutlinedInput-root': {
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: hasIncompleteSearch ? 'error.main' : undefined,
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: hasIncompleteSearch ? 'error.dark' : undefined,
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: hasIncompleteSearch ? 'error.main' : undefined,
          },
        },
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon color={hasIncompleteSearch ? 'error' : 'inherit'} fontSize="small" />
          </InputAdornment>
        ),
      }}
    />
  );
};

export default MinimumLengthSearchField;
